import React from "react";
import "./react-tabs.css";
import SubmitButton from "../reusableComponents/SubmitButton";
import Table from "../reusableComponents/ReactTable";
import { alertService } from "../common/alert.service";
import { Box, Grid, FormControlLabel, Checkbox, FormControl, FormGroup } from "@material-ui/core";
import PopUp from "../reusableComponents/PopUp";
import { timeout } from "rxjs/operators";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";
import TableControlled from "../reusableComponents/TableControlled";
import Can from "../authentication/Can";
import UserStore from "../../stores/UserStore";
import { DropdownList, Multiselect } from "react-widgets";
import TextBox from "../reusableComponents/TextBox";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Tooltip from "@material-ui/core/Tooltip";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

class Snags extends React.Component {
    constructor(props){
      super(props);
      this._isMounted = false;
      this.state= {
        loadedDetails: false,
        largeScreen: true,
        locationFilter: "",
        skuFilters:[],
        employeeFilters:[],
        skuFilter: "",
        allSKUs:[],
        allEmployees:[],
        locations: [],
        tech: "",
        streetAddress: "",
        suite: "",
        city: "",
        stateProvince: "",
        postalCode: "",
        country: "",
        email: "",
        phoneNumber: "",
        shippingInstructions: "",
        shipToOtherTech: "",
        attPartNumber: "",
        serialNumber: "",
        assetTag: "",
        partDescription: "",
        failureInformation: "",

        //current web app user info
        user: {},
      }
      this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentDidMount() {
      this._isMounted = true;
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));
      this._isMounted && this.setState({
        loadedDetails: true,
        locations: ["USA","Canada"]
      });
      await this.getProducts(0, 50, [""]);
      await this.getUser();
    }

    async componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    updateDimensions(){
      if (window.innerWidth > 960) {
        this.setInputValue('largeScreen',true)
      } else {
        this.setInputValue('largeScreen',false)
      }
    }

    setInputValue(property, val) {
      this._isMounted && this.setState(
        {
          [property]: val,
        },
      () => {
        if (property === "skuFilter") {
          this.applySKUFilter();
        }
      }
      );
    }

    handleInputChange(event){
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
  
      this._isMounted && this.setState(
        {
          [name]: value,
        },
        () => {
          if (name === "locationFilter") {
            this.applyFilter();
          }
          if (name === "selectedSnagWarranty" && value !== "" && value){
            this.setState({selectedSnagWarrantyStatus: ""})
            this.checkWarrantyStatus()
          }
        }
      );
    }

    applySKUFilter(){
      this.getProducts(0,50,[this.state.skuFilter])
    }

    async createATTNBDPreAlerts(){
      const requiredFields = {
        email: "Technician Email",
        skuFilter: "MFG Part Code",
        attPartNumber: "AT&T Part Number",
        serialNumber: "MFG Serial Number",
        assetTag: "AT&T Asset Tag",
      };
      const missingFields = Object.keys(requiredFields)
        .filter(field => !String(this.state[field] || "").trim())
        .map(field => requiredFields[field]);

      if (missingFields.length > 0) {
        alertService.error("Please complete the required fields: " + missingFields.join(", ") + ".");
        return;
      }

      try {
        let res = await fetch("/createATTNBDPreAlerts", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tech : this.state.tech,
            streetAddress : this.state.streetAddress,
            suite : this.state.suite,
            city : this.state.city,
            state : this.state.stateProvince,
            postalCode : this.state.postalCode,
            country : this.state.country,
            email : this.state.email,
            phoneNumber : this.state.phoneNumber,
            instructions : this.state.shippingInstructions,
            sku : this.state.skuFilter,
            attPartNumber : this.state.attPartNumber,
            sn : this.state.serialNumber,
            assetTag : this.state.assetTag,
            partDescription : this.state.partDescription,
            failureInformation : this.state.failureInformation,
            shipToOtherTech : this.state.shipToOtherTech,
          }),
        });
  
        let result = await res.json();
        if (result.success === true) {
          this.setState({
            tech: "",
            streetAddress: "",
            suite: "",
            city: "",
            stateProvince: "",
            postalCode: "",
            country: "",
            email: "",
            phoneNumber: "",
            shippingInstructions: "",
            skuFilter: "",
            attPartNumber: "",
            serialNumber: "",
            assetTag: "",
            partDescription: "",
            failureInformation: "",
            shipToOtherTech: "",
          });
          this.getProducts(0, 50, [""]);
          alertService.success("Successfully submitted the form with PO " + result.ponum + ".");
        } else {
          console.log(result.msg);
        }
      } catch (e) {
        console.log(e);
      }
    }

    async getProducts(pageIndex, pageSize, filters){
      try {
        let res = await fetch("/getProducts", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pageSize: pageSize,
            SKUFilter: filters[0],
          }),
        });
  
        let result = await res.json();
        if (result.products && result.success) {
          let resultSKUList = []
          result.products.forEach(element => {
            resultSKUList.push(element.sku)
          });
          this._isMounted && this.setState({ allSKUs: resultSKUList });
        } else if (result && result.success === false) {
          console.log(result.msg);
        }
      } catch (e) {
        console.log(e);
      }
    }
    
    async getUser() {
      if (!UserStore.isLoggedIn) {
        return;
      }
      try {
        let res = await fetch("/getUser", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
  
        let result = await res.json();
  
        if (result && result.success) {
          this._isMounted && this.setState({ 
            user: result.user, 
            tech: result.user.first_name + " " + result.user.last_name, 
            email: result.user.email, 
            phoneNumber: result.user.phoneNumber 
          });
        }
      } catch (e) {
        console.log(e);
      }
    }

    render(){
      const RedRadioButton = withStyles({
        root: {
            color: red[400],
            '&$checked': {
                color: red[600],
            },
        },
        checked: {},
        })((props) => <Radio color="default" {...props} />);

        if (!this.state.loadedDetails) {
          return (
            <div className="app">
              <div className="container2">Loading...</div>
            </div>
          );
        }
        return(
            <div className="app">
              <div className="container2">
                  <Tabs>
                    <TabList>
                      <Tab>AT&T Cisco Next Business Day Program</Tab>
                    </TabList>
                    <TabPanel>
                      <div className="box stretch">
                        <Box flexDirection="column" display="flex" width="100%">
                          <h2>Technician Information:</h2>
                          <Box flexDirection="column" display="flex">

                              <Box p={2}>
                                <TextBox
                                  label="Technician Name"
                                  type="text"
                                  value={this.state.tech}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("tech", value);
                                  }}
                                  disabled
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Street Address"
                                  type="text"
                                  value={this.state.streetAddress}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("streetAddress", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Apartment, suite, etc"
                                  type="text"
                                  value={this.state.suite}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("suite", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="City"
                                  type="text"
                                  value={this.state.city}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("city", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="State/Province"
                                  type="text"
                                  value={this.state.stateProvince}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("stateProvince", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="ZIP/Postal Code"
                                  type="text"
                                  value={this.state.postalCode}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("postalCode", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <div>Country:</div>
                                <DropdownList
                                  className="medium"
                                  filter={true}
                                  data={this.state.locations}
                                  value={this.state.country}
                                  onChange={value=> {
                                    this.setInputValue("country", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Technician Email*"
                                  type="text"
                                  value={this.state.email}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("email", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Technician Phone Number"
                                  type="text"
                                  value={this.state.phoneNumber}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("phoneNumber", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Special Shipping Instructions"
                                  type="text"
                                  value={this.state.shippingInstructions}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("shippingInstructions", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Ship To Technician If Different From Requester"
                                  type="text"
                                  value={this.state.shipToOtherTech}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("shipToOtherTech", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>

                          </Box>
                        </Box>
                      </div>
                      
                      <div className="box stretch">
                        <Box flexDirection="column" display="flex" width="100%">
                          <h2>Defective Part Information:</h2>
                          <Box flexDirection="column" display="flex">
                              <Box p={2}>
                                <div>MFG Part Code*:</div>
                                <DropdownList
                                  filter
                                  className="medium"
                                  data={this.state.allSKUs}
                                  value={this.state.skuFilter ? this.state.skuFilter : ""}
                                  onSearch={(searchTerm) =>
                                    this.getProducts(0, 50, [searchTerm, ""])
                                  }
                                  onChange={(val) => this.setInputValue("skuFilter", val)}
                                  textField="sku"
                                  minLength={3}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="AT&T Part Number*"
                                  type="text"
                                  value={this.state.attPartNumber}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("attPartNumber", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="MFG Serial Number*"
                                  type="text"
                                  value={this.state.serialNumber}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("serialNumber", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="AT&T Asset Tag*"
                                  type="text"
                                  value={this.state.assetTag}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("assetTag", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Part Description"
                                  type="text"
                                  value={this.state.partDescription}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("partDescription", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                              <Box p={2}>
                                <TextBox
                                  label="Failure Information of Fault Description"
                                  type="text"
                                  value={this.state.failureInformation}
                                  onChange={event => {
                                    const { value } = event.target;
                                    this.setInputValue("failureInformation", value);
                                  }}
                                  onKeyDown={(e) => {}}
                                />
                              </Box>
                          </Box>
                        </Box>
                      </div>
                    </TabPanel>
                    <SubmitButton
                      text="Submit"
                      onClick={() => {
                        this.createATTNBDPreAlerts();
                      }}
                    />
                  </Tabs>
                </div>
            </div>
        )
    }
}

export default Snags
